export const CHAT_FEATURES = false;
export const PROFILE_FEATURES = false;
export const SETTINGS_FEATURES = false;
export const NOTIFICATIONS_FEATURES = false;
export const MESSAGES_FEATURES = false;
export const CATEGORY_FEATURES = false;
